var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box divBox" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 14, type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c("el-card", { attrs: { "body-style": "padding:0" } }, [
                _c(
                  "ul",
                  { staticClass: "header-need" },
                  _vm._l(_vm.needInfo, function (item, index) {
                    return _c(
                      "li",
                      {
                        key: "needInfo" + index,
                        on: {
                          click: function ($event) {
                            return _vm.needInfoItem(item)
                          },
                        },
                      },
                      [
                        _c("el-image", {
                          staticClass: "image",
                          attrs: { src: item.icon },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "header-need-right" }, [
                          _c("p", { staticClass: "num" }, [
                            _vm._v(_vm._s(item.num)),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "text" }, [
                            _vm._v(_vm._s(item.text)),
                          ]),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c("el-card", { attrs: { "body-style": "padding:0" } }, [
                _c(
                  "div",
                  { staticClass: "header-pic" },
                  [
                    _c("el-image", {
                      staticClass: "image",
                      attrs: {
                        src: require("@/assets/images/personal-logo.png"),
                        fit: "cover",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _c("div", { staticClass: "over-text1" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.realName) +
                            ",\n              "
                        ),
                        _c("span", { staticClass: "time" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.noon === "am"
                                  ? _vm.$t("user.work.goodmorning")
                                  : _vm.$t("user.work.goodafternoon")
                              ) +
                              "！\n              "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info over-text2" }, [
                        _vm._v(_vm._s(_vm.enterprise.culture)),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt14", attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-card",
                { attrs: { "body-style": "padding:20px; height:150px" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "calendar_title achievementPb" },
                    [
                      _c(
                        "el-col",
                        { staticClass: "row-middle", attrs: { span: 12 } },
                        [
                          _c(
                            "div",
                            { staticClass: "dynamics" },
                            [
                              _vm._v(
                                "\n              业绩统计\n              "
                              ),
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "110px" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择",
                                  },
                                  on: { change: _vm.workStatisticsList },
                                  model: {
                                    value: _vm.achievementTypes,
                                    callback: function ($$v) {
                                      _vm.achievementTypes = $$v
                                    },
                                    expression: "achievementTypes",
                                  },
                                },
                                _vm._l(_vm.options, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "text-right calendar_title-left",
                          attrs: { span: 12 },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "display-align",
                              on: { click: _vm.handlePerformance },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont iconpcshouye-guanli",
                              }),
                              _vm._v("\n              管理\n            "),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "achievementContent" },
                    _vm._l(_vm.achievementList, function (item, index) {
                      return _c("div", { key: index, staticClass: "item" }, [
                        _c("span", { staticClass: "num" }, [
                          _vm._v(_vm._s(item.value)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(item.title)),
                        ]),
                      ])
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt14", attrs: { gutter: 14, type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 16 } },
            [
              _c(
                "el-card",
                { attrs: { "body-style": "padding:0;" } },
                [
                  _c(
                    "el-row",
                    { staticClass: "calendar_title clearfix calendar-dealt" },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "acea-row row-middle",
                          attrs: { span: 12 },
                        },
                        [
                          _c("div", { staticClass: "dynamics" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.time) +
                                " 待办\n              "
                            ),
                            _c("i", {
                              staticClass: "iconfont dynamics-icon",
                              class: _vm.pend.status
                                ? "iconyincang"
                                : "icondakai",
                              style: {
                                visibility: _vm.hasFinished
                                  ? "visible"
                                  : "hidden",
                              },
                              attrs: {
                                title:
                                  (_vm.pend.status ? "隐藏" : "显示") +
                                  "已完成的待办",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.pend.status = _vm.pend.status ? 0 : 3
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { staticClass: "text-right", attrs: { span: 12 } },
                        [
                          _c(
                            "el-button-group",
                            {
                              model: {
                                value: _vm.timeTab,
                                callback: function ($$v) {
                                  _vm.timeTab = $$v
                                },
                                expression: "timeTab",
                              },
                            },
                            _vm._l(_vm.timeTabData, function (item, index) {
                              return _c(
                                "el-button",
                                {
                                  key: index,
                                  class:
                                    _vm.timeTabIndex === index ? "active" : "",
                                  attrs: { size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.timeTabInput(item, index)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.text))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _vm.needList.length &&
                      (_vm.hasUnfinished || _vm.pend.status)
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.timeTabLoading,
                                  expression: "timeTabLoading",
                                },
                              ],
                              staticClass: "dealt-content-list",
                            },
                            [
                              _c("el-image", {
                                staticClass: "dealt-content-image",
                                attrs: {
                                  src: require("@/assets/images/index/index-logo.png"),
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-scrollbar",
                                {
                                  staticStyle: {
                                    height: "100%",
                                    width: "100%",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "calendar-dealt-list" },
                                    _vm._l(
                                      _vm.needList,
                                      function (item, index) {
                                        return _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  _vm.pend.status == 0
                                                    ? item.finish <= 1
                                                    : item.finish >= -1,
                                                expression:
                                                  "pend.status == 0 ? item.finish <= 1 : item.finish >= -1",
                                              },
                                            ],
                                            key: "need" + index,
                                            staticClass: "item",
                                            class:
                                              item.finish === 1 ? "active" : "",
                                            style: {
                                              "--fill-color": item.color,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item-list" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "over-text2" },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "pointer",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleItemClick(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.title)
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                [2, 3, 4, 5].includes(item.cid)
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "time" },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              item.remind
                                                                ? item.remind
                                                                    .remind_time
                                                                : "09:00:00"
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      { staticClass: "time" },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm
                                                                .$moment(
                                                                  item.start_time
                                                                )
                                                                .format(
                                                                  "HH:mm:ss"
                                                                )
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            item.finish == 3
                                              ? _c("i", {
                                                  staticClass:
                                                    "dealt-icon el-icon-success",
                                                  style: { color: item.color },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setScheduleRecord(
                                                        item,
                                                        0
                                                      )
                                                    },
                                                  },
                                                })
                                              : item.finish == 2
                                              ? _c("i", {
                                                  staticClass:
                                                    "dealt-icon el-icon-error",
                                                  style: { color: item.color },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setScheduleRecord(
                                                        2
                                                      )
                                                    },
                                                  },
                                                })
                                              : _c("i", {
                                                  staticClass:
                                                    "dealt-icon yuan",
                                                  style: { color: item.color },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setScheduleRecord(
                                                        item,
                                                        3
                                                      )
                                                    },
                                                  },
                                                }),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _c("default-page", {
                            attrs: { "min-height": 294, index: 14 },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-card",
                { attrs: { "body-style": "padding:0" } },
                [
                  _c(
                    "el-row",
                    {
                      staticClass: "calendar_title",
                      staticStyle: { "padding-bottom": "12px" },
                    },
                    [
                      _c(
                        "el-col",
                        { staticClass: "row-middle", attrs: { span: 12 } },
                        [
                          _c("div", { staticClass: "dynamics" }, [
                            _vm._v("快捷入口"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticClass: "text-right calendar_title-left",
                          attrs: { span: 12 },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "display-align",
                              on: { click: _vm.handleQuick },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont iconpcshouye-guanli",
                              }),
                              _vm._v("\n              管理\n            "),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "quick-content" },
                    [
                      _vm.quickVal.length > 0
                        ? _c(
                            "div",
                            { staticClass: "quick-list" },
                            _vm._l(_vm.quickVal, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: "quick" + index,
                                  staticClass: "quick-list-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.quickItem(item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "pointer" },
                                    [
                                      _c("el-image", {
                                        staticClass: "image",
                                        attrs: { src: item.image },
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "name" }, [
                                        _vm._v(_vm._s(item.name)),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            0
                          )
                        : _c("default-page", {
                            attrs: { "min-height": 294, index: 14 },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "mt14", attrs: { gutter: 14 } },
        [
          _vm.assessLoading && _vm.assessNowData.length > 0
            ? [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-card",
                      { attrs: { "body-style": "padding:0" } },
                      [
                        _c("div", { staticClass: "calendar_title clearfix" }, [
                          _c(
                            "div",
                            { staticClass: "pull-left acea-row row-middle" },
                            [
                              _c("div", { staticClass: "dynamics" }, [
                                _vm._v("当前考核"),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pull-right acea-row row-middle" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "notice-more",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleAssessMore()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                更多\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "el-icon-arrow-right",
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("echarts", {
                          attrs: { id: _vm.assessNowData[0].id },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-col",
            {
              attrs: {
                span:
                  _vm.assessLoading && _vm.assessNowData.length > 0 ? 8 : 16,
              },
            },
            [
              _c(
                "el-card",
                {
                  staticClass: "table-box note",
                  attrs: { "body-style": "padding:0" },
                },
                [
                  _c("div", { staticClass: "calendar_title clearfix" }, [
                    _c(
                      "div",
                      { staticClass: "pull-left acea-row row-middle" },
                      [
                        _c("div", { staticClass: "dynamics" }, [
                          _vm._v("系统通知"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pull-right acea-row row-middle" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "notice-more",
                            on: {
                              click: function ($event) {
                                return _vm.handleNewMore()
                              },
                            },
                          },
                          [
                            _vm._v("\n              更多\n              "),
                            _c("i", { staticClass: "el-icon-arrow-right" }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.systemNote.length
                    ? _c(
                        "div",
                        {
                          staticClass: "list",
                          staticStyle: { height: "406px" },
                        },
                        _vm._l(_vm.systemNote, function (item, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass:
                                "item acea-row row-between-wrapper pointer",
                              class: item.is_read ? "finish" : "",
                              on: {
                                click: function ($event) {
                                  return _vm.handleDetails(item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "item-list system-note" },
                                [
                                  _c("div", { staticClass: "line1" }, [
                                    _c("span", { staticClass: "label" }, [
                                      _vm._v("【" + _vm._s(item.title) + "】"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(item.message))]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "time" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .$moment(item.created_at)
                                          .format("MM-DD HH:mm")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      )
                    : _c("default-page", {
                        attrs: { "min-height": 406, index: 14 },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-card",
                { attrs: { "body-style": "padding:0" } },
                [
                  _c("div", { staticClass: "calendar_title clearfix" }, [
                    _c(
                      "div",
                      { staticClass: "pull-left acea-row row-middle" },
                      [
                        _c("div", { staticClass: "dynamics" }, [
                          _vm._v("企业动态"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "pull-right acea-row row-middle" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "notice-more",
                            on: {
                              click: function ($event) {
                                return _vm.handleNoticeMore("")
                              },
                            },
                          },
                          [
                            _vm._v("\n              更多\n              "),
                            _c("i", { staticClass: "el-icon-arrow-right" }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.nweNoticeData.length > 0
                    ? _c(
                        "ul",
                        { staticClass: "news-content" },
                        _vm._l(_vm.nweNoticeData.slice(0, 5), function (item) {
                          return _c(
                            "li",
                            {
                              key: "new" + item.id,
                              on: {
                                click: function ($event) {
                                  return _vm.handleNoticeMore(item.id)
                                },
                              },
                            },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 14 } },
                                [
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "notice-left",
                                      class: item.cover ? "" : "width100",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "title over-text" },
                                        [_vm._v(_vm._s(item.title))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "bottom" }, [
                                        _c("span", [
                                          _c("i", {
                                            staticClass: "iconfont iconyiyuedu",
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item.visit) +
                                              "\n                  "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("span", [
                                          _c("i", {
                                            staticClass:
                                              "iconfont iconriqishijian",
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                item.push_time.split(" ")[0]
                                              ) +
                                              "\n                  "
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.cover
                                    ? _c(
                                        "el-col",
                                        { staticClass: "notice-right" },
                                        [
                                          item.cover
                                            ? _c("img", {
                                                attrs: {
                                                  src: item.cover,
                                                  alt: "",
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _c("default-page", {
                        attrs: { "min-height": 406, index: 14 },
                      }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("password", {
        ref: "password",
        attrs: { "form-data": _vm.passwordData },
      }),
      _vm._v(" "),
      _vm.noticeListVisible
        ? _c("noticeList", { ref: "noticeList" })
        : _vm._e(),
      _vm._v(" "),
      _vm.calendarDetailsVisible
        ? _c("calendarDetails", {
            ref: "calendarDetails",
            on: { deleteFn: _vm.getDailyTodo, editFn: _vm.editFn },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("message-details", {
        ref: "messageDetails",
        attrs: { "message-data": _vm.messageData },
      }),
      _vm._v(" "),
      _c("quick-manage", {
        ref: "quickManage",
        attrs: { config: _vm.configData },
        on: { isSuccess: _vm.quickSuccess },
      }),
      _vm._v(" "),
      _vm.addTodoVisible
        ? _c("addTodo", { ref: "addTodo", on: { getList: _vm.getDailyTodo } })
        : _vm._e(),
      _vm._v(" "),
      _vm.contractDialogVisible
        ? _c("contract-dialog", {
            ref: "contractDialog",
            attrs: { config: _vm.configContract },
            on: { isOk: _vm.getDailyTodo },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "record",
          attrs: {
            title: "添加跟进记录",
            visible: _vm.dialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("recordUpload", {
            attrs: { "form-info": _vm.formInfo },
            on: { change: _vm.recordChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        attrs: { parameterData: _vm.parameterData, ids: _vm.formInfo.data.id },
        on: { scheduleRecord: _vm.scheduleRecord },
      }),
      _vm._v(" "),
      _c("copyright"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }